export default __webpack_public_path__ + "static/media/misc-books3-2048w.99f8956f.png";